import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function About() {
  return (
    <section id="about" className="about-section">
      <Container>
        <h2 className="section-header">
          ABOUT<span className="purple"> ME</span>
        </h2>

        {/* About Me Content */}
        <Row className="about-content justify-content-center">
          <Col md={5} className="about-text">
            <p>
              Software Engineer with 2+ years of experience building end-to-end
              production systems across{" "}
              <b className="purple">backend pipelines</b>,{" "}
              <b className="purple">cloud infrastructure</b>,{" "}
              <b className="purple">AI integration</b>, and{" "}
              <b className="purple">frontend applications</b>.
            </p>
          </Col>

          <Col md={5} className="about-text">
            <p>
              As a founding engineer, I shipped an enterprise MVP from 0 to 1,
              owning the full product lifecycle from{" "}
              <b className="purple">architecture</b> and{" "}
              <b className="purple">development</b> to{" "}
              <b className="purple">deployment</b> and{" "}
              <b className="purple">customer onboarding</b>, launching in under
              5 months with 3 enterprise beta customers.
            </p>
          </Col>

          <Col md={5} className="about-text">
            <p>
              My work spans <b className="purple">AI agents</b> and{" "}
              <b className="purple">ETL pipelines</b>,{" "}
              <b className="purple">AWS cloud infrastructure</b>, and{" "}
              <b className="purple">full-stack applications</b> with TypeScript,
              React, Next.js, Spring Boot, and PostgreSQL. From building
              enterprise B2B portals to engineering AI-powered automation
              workflows, I bring depth across the{" "}
              <b className="purple">backend</b>,{" "}
              <b className="purple">frontend</b>, and{" "}
              <b className="purple">cloud</b>.
            </p>
          </Col>

          <Col md={5} className="about-text">
            <p>
              I'm most effective when I can own a problem end-to-end, from{" "}
              <b className="purple">database schema</b> to{" "}
              <b className="purple">deployment</b>. I value{" "}
              <b className="purple">clean architecture</b>, shipping with{" "}
              <b className="purple">velocity</b>, and building systems that hold
              up at <b className="purple">scale</b>.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;
